'use es6';

import { Map as ImmutableMap } from 'immutable';
import { StringDisplayType } from 'customer-data-filters/filterQueryFormat/DisplayTypes';
import DSFieldRecord from 'customer-data-filters/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';
export default (({
  filterFamily,
  displayType = StringDisplayType
}) => DSFieldRecord({
  displayType,
  label: I18n.text(`customerDataFilters.DSAssetFamilyNames.${filterFamily}`),
  metadata: ImmutableMap({
    hasNoFieldOptions: true
  }),
  name: filterFamily,
  type: filterFamily
}));